import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'logged_out_retailers-logged_out_home_redesign-view';

/**
 * track view events on logged out home (redesign)
parameter: banner name
 */
export function trackLoggedOutRetailersLoggedOutHomeRedesignView(
  banner_name: string,
  variant_string2: string = 'CONTROL'
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { banner_name, variant_string2 },
  });
}
